/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import Speed20Icon from "../../../assets/icons/traffic/toggleable/IconSpeedZeroToTwentyKmH";
import Speed30Icon from "../../../assets/icons/traffic/toggleable/IconSpeedTwentyOneToThirtyKmH";
import Speed40Icon from "../../../assets/icons/traffic/toggleable/IconSpeedThirtyOneToFortyKmH";
import Speed40MoreIcon from "../../../assets/icons/traffic/toggleable/IconSpeedMoreThanFortyKmH";
import QuestionIcon from "../../../assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

export default function DistanceSpeed({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="speed"
                question={translate("traffic.speed.label", values)}
                options={[
                  {
                    labelText: translate("traffic.speed.options.<81.label", values),
                    labelIcon: <Speed20Icon />,
                    labelIconActive: <Speed20Icon active />,
                    value: "<81",
                  },
                  {
                    labelText: translate("traffic.speed.options.81-100.label", values),
                    labelIcon: <Speed30Icon />,
                    labelIconActive: <Speed30Icon active />,
                    value: "81-100",
                  },
                  {
                    labelText: translate("traffic.speed.options.101-130.label", values),
                    labelIcon: <Speed40Icon />,
                    labelIconActive: <Speed40Icon active />,
                    value: "101-130",
                  },
                  {
                    labelText: translate("traffic.speed.options.>130.label", values),
                    labelIcon: <Speed40MoreIcon />,
                    labelIconActive: <Speed40MoreIcon active />,
                    value: ">130",
                  },
                  {
                    labelText: translate("traffic.speed.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
